import { useWorkflowNames } from "../data/workflow";
import { Dropdown } from ".";
import { useMemo, memo } from "react";

function WorkflowNameInput(props) {
  const { data, refetch, isFetching } = useWorkflowNames();

  const options = useMemo(() => {
    return Array.isArray(data) ? data : [];
  }, [data]);

  return (
    <Dropdown
      label={props.label || "Workflow Reference Name"}
      options={options}
      multiple
      freeSolo={false}
      loading={isFetching || options.length === 0}
      {...props}
    />
  );
}

export default memo(WorkflowNameInput);
